import { render } from "./HomeView.vue?vue&type=template&id=09825ccf&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=09825ccf&lang=scss"

import exportComponent from "/Users/mmartinez/Desktop/personal/suburban relapse/suburban-relapse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__